import React, { Component } from "react";
import axios from "axios";
import { apiHost } from "../../api/apiClient";
import NewsModal from "./newsModal";
import "../../styles/news/news.scss";

class NewsLoginModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeNews: null,
      show: false,
    };
  }

  componentDidMount() {
    if (window.location.pathname === "/login" || !localStorage.getItem("token")) {
      return;
    }

    this.loadActiveNews();
  }

  loadActiveNews = async () => {
    try {
      const response = await axios.get(`${apiHost}/api/News/Active`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      if (response.status === 200 && response.data && response.data.id) {
        this.setState({ activeNews: response.data, show: true });
      }
    } catch (error) {
      console.log(`News active communication request failed: ${error}`);
    }
  };

  handleClose = async () => {
    const activeNews = this.state.activeNews;
    this.setState({ show: false });

    if (!activeNews) {
      return;
    }

    try {
      await axios.post(
        `${apiHost}/api/News/${activeNews.id}/Acknowledge`,
        { version: activeNews.version },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
    } catch (error) {
      console.log(`News acknowledgement request failed: ${error}`);
    }
  };

  render() {
    return (
      <NewsModal
        item={this.state.activeNews}
        show={this.state.show}
        onHide={this.handleClose}
        onCloseLabel="Close"
      />
    );
  }
}

export default NewsLoginModal;
